function isChsMsg(msg) {
  for (let idx in msg) {
    if (msg.charCodeAt(idx) < 32 || msg.charCodeAt(idx) > 126) {
      return true
    }
  }
  return false
}

export default isChsMsg